// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"325":"296659b4","709":"01ad7292"}[chunkId] + ".chunk.js";
};